import React from 'react';
import {
  View,
  Text,
  ImageBackground,
  Image,
  Dimensions,
  TouchableOpacity,
  ActivityIndicator,
  Platform
} from 'react-native';
import styles from '../../style/scanpack';
import axios from 'axios';
import globalStyles from '../../style/global';
import {LinearGradient} from 'expo-linear-gradient';
import backImage from '../../../assets/bg_right.png';
import backNewImage from '../../../assets/Right_new2.jpg';
import placeholder from '../../../assets/placeholder.jpg';
import {fontFamily} from '../../helpers/fontFamily';
import BoxChampReopenPrompt from './BoxChampReopenPrompt';
import {reopenTarget} from './boxChampReopen';
import {createGuidedViewMemo} from './boxChampGuided';
import ScanImageComponent from './ScanImageComponent';
import {
  AddBox,
  GetOrderDetail,
  RemoveBoxItems,
  PrintSlip,
  LoaderShow
} from '../../actions/orderActions';
import {SortList, filterScannedList} from '../../helpers/scanPackFunctions';
import _ from 'lodash';
import {connect} from 'react-redux';
import OrderItem from '../../commons/orderItem';
import {GetProductDetail} from '../../actions/productAction';
import OrderItemImage from '../../commons/orderItemImage';
import DisplayQuantityInBox from '../../commons/displayQunatityInBox';
import AsyncStorage from '@react-native-async-storage/async-storage';
import ScannedKitItem from '../../commons/scannedKitItem';
import ScannedKitItemContainer from '../../commons/ScannedKitItemContainer';
import I18n from 'i18n-js';
import CustomScrollBar from '../../commons/customScrollBar';

let count = 0;

class ScannedItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      boxChampReopenBox: null,
      boxChampPendingRemoval: null,
      prevButton: 0,
      nextButton: 0,
      scannedItemPerPage: 1,
      imageFlag: [],
      data: {
        filter: 'awaiting',
        order: 'DESC',
        limit: '1',
        offset: '0'
      }
    };
  }
  imageCheck = err => {
    let ll = err.nativeEvent.error.includes('404');
    this.setState({imageFlag: [this.state.imageFlag, ll]});
  };

  componentWillUnmount(){
    let unscannedList = this.props?.order?.order?.unscanned_items
    const boxChampPlanned = (this.props?.Order?.boxes || []).some(
      b => b && b.source === 'box_champ'
    );
    if(unscannedList?.length === 0 && !boxChampPlanned){
      this.addBoxMultiBox()
    }
    let multiboxSetting = this.props?.bothSettings?.data?.data?.general_setting;
    if(
      unscannedList?.length == 0 &&
      multiboxSetting?.per_box_packing_slips === 'when_order_is_complete' &&
      multiboxSetting?.multi_box_shipments
    ) {
      this.orderCompletePrintSlip();
      return false;
    }
  }

  orderCompletePrintSlip = () => {
    let arrayempty = [];
    this?.props?.Order?.boxes?.map((item, index) => {
      arrayempty.push(item.id);
    });
    let item = {
      box_ids: arrayempty,
      orderArray: [{id: this.props?.Order?.basicinfo?.id}]
    };
    this.props.PrintSlip(item);
  };

  GetOrderDetail = async detail => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    const updatedData = await axios({
      method: 'get',
      url: `${url}/orders/${detail?.id?.id}.json`,
      headers: {Authorization: `Bearer ${access_token}`}
    });
    return updatedData.data.order;
  };

  addBoxMultiBox = async () => {
    const boxChampPlanned = (this.props?.Order?.boxes || []).some(
      b => b && b.source === 'box_champ'
    );
    if (boxChampPlanned) {
      // The backend silently no-ops a manual box on a BoxChamp-planned order
      // (Box#refuse_manual_box_on_planned_order); surface that here instead.
      if (this.props.showAlert) {
        this.props.showAlert(I18n.t('product.alertBoxChampPlanned'));
      }
      return;
    }
    let updatedDataAPI;
    let multi_box_shipments =  this.props?.bothSettings?.data?.data?.general_setting?.multi_box_shipments
    if(this.props.isConnected) {
       updatedDataAPI = await this.GetOrderDetail({id: this.props?.order?.order});
    }
    let saveOfflineOrders = updatedDataAPI ?? this.props.orderDetails
    let addBoxPrintSlip =
      this.props?.bothSettings?.data?.data?.general_setting
        ?.per_box_packing_slips;
    let perBoxShippingLabelCreation =
      this.props?.bothSettings?.data?.data?.general_setting
        ?.per_box_shipping_label_creation;
    let boxItemProps = saveOfflineOrders?.order_item_boxes;
    // let boxItemProps = this.props?.Order?.order_item_boxes;
    let boxProps = this.props?.Order?.boxes;
    let boxFilter = boxItemProps?.filter(
      i => i.box_id == boxProps[boxProps.length - 1]?.id
    );
    let item = {
      name: `Box ${this?.props?.Order?.boxes.length + 1}`,
      order_id: this.props?.Order?.basicinfo?.id
    };

    if(boxItemProps[boxProps?.length - 1] && boxFilter?.length && !this.props.isConnected){
      let boxObject = boxProps[boxProps.length -1]
      boxProps.push({name : item.name, id :typeof boxObject.id !== 'number' ? `unique ${boxObject?.id.split('-')[1]+1 }`: boxProps[boxProps.length -1]?.id + 1})
      this.props.goNext()
    }else if(!this.props.isConnected && multi_box_shipments ){
        this.props.multiBoxStateUpdate()
    }
    if (boxItemProps[boxProps?.length - 1] && boxFilter.length > 0) {
      if (addBoxPrintSlip === 'when_new_boxes_are_started') {
        this.props.printSlipFun();
      }
      this.props.AddBox(item, this.props.goNext, (responseData) => {
        if (
          perBoxShippingLabelCreation === 'per_box_shipping_label_creation_after_box' &&
          responseData?.ss_label_data &&
          Object.keys(responseData.ss_label_data).length > 0
        ) {
          this.props.navigation.navigate('ShippingLabel', {
            time: new Date(),
            setting: this.props?.bothSettings?.data?.data,
            navigation: this.props?.navigation || null,
            userRole: this.props?.route?.params?.userdata || null,
            basicinfo: this.props?.Order?.basicinfo,
            directPrintingSetting:
              this.props?.bothSettings?.data?.data?.general_setting
                ?.print_ss_shipping_labels,
            isolatedComponent: true,
            returnToScanPack: true, // Flag to indicate should return to scanning
            multiBoxMode: true, // Flag to indicate this is multibox mode
            currentOrderId: this.props?.Order?.basicinfo?.increment_id || this.props?.Order?.order?.increment_id,
            presentationStyle: 'modal', // Open as modal instead of full screen navigation
            ss_label_data: responseData.ss_label_data
          });
        }
      });
    } else {
      if(this.props.isConnected && multi_box_shipments) this.props.multiBoxStateUpdate();
    }
  };

  getBoxChampView = () => {
    if (!this._guidedViewMemo) this._guidedViewMemo = createGuidedViewMemo();
    return this._guidedViewMemo(this.props?.order?.order, [
      this.props.Order,
      this.props?.order?.order
    ]);
  };

  removeBoxItem = async (box_id, order_item_id, kit_product_id) => {
    const sealed = reopenTarget({
      view: this.getBoxChampView(),
      orderItemId: order_item_id,
      kitId: kit_product_id ?? null,
      preferredBoxId: box_id ?? null,
      sealConfirmedBoxIds: this.props.boxChampSealConfirmedBoxIds
    });
    if (sealed && !this.state.boxChampPendingRemoval) {
      this.setState({
        boxChampReopenBox: sealed,
        boxChampPendingRemoval: {box_id, order_item_id, kit_product_id}
      });
      return;
    }
    this.setState({boxChampReopenBox: null, boxChampPendingRemoval: null});
    await this.performRemoveBoxItem(box_id, order_item_id, kit_product_id);
  };

  confirmBoxChampReopen = () => {
    const pending = this.state.boxChampPendingRemoval;
    this.setState({boxChampReopenBox: null, boxChampPendingRemoval: null}, () => {
      if (pending) {
        this.performRemoveBoxItem(
          pending.box_id,
          pending.order_item_id,
          pending.kit_product_id
        );
      }
    });
  };

  cancelBoxChampReopen = () =>
    this.setState({boxChampReopenBox: null, boxChampPendingRemoval: null});

  performRemoveBoxItem = async (box_id, order_item_id, kit_product_id) => {
    const id = this.props?.Order?.basicinfo?.id;
    let data = {
      box_id,
      kit_product_id,
      order_item_id,
      id
    };
    if(!this.props.isConnected){
      this.props.multiBoxStateUpdate()
  }else{
    this.props.RemoveBoxItems(data);
    setTimeout(() => {
      this.props.updateOrder(this?.props?.order?.order?.increment_id);
    }, 300);
    }
  };

  checky = boxId => {
    if (boxId) {
      return this.props?.Order.order_item_boxes
        .filter(data => data.box_id === boxId)
        .map(data => data.item_qty)
        .reduce((a, b) => a + b, 0);
    }
    return 0;
  };

  // GROOV-4994 (bugs 1 & 2): this.props.activeBoxIndex is a navigation cursor owned by
  // scanpack_item.js that only advances via goPrev/goNext clicks or a box-barcode-scan
  // match — it is never touched by confirmBoxChampHandoff, which is what actually
  // seals/advances a box on both the confirm-card tap and the box-scan-verification
  // seal-scan path. That left this panel showing the just-completed box's name/position
  // (bug 1) until the packer separately clicked "Next" here.
  //
  // getBoxChampView() (already built above, for the reopen-prompt check) recomputes
  // view.projection from the real per-box scanned/target data on every render, so it can
  // never go stale the way activeBoxIndex can. Prefer its activeIndex/activeBoxId
  // whenever a BoxChamp plan exists (getBoxChampView returns null otherwise), and fall
  // back to the legacy activeBoxIndex prop for ordinary non-BoxChamp multi-box orders —
  // where this component's original (pre-existing, out of scope) behavior is preserved
  // unchanged.
  //
  // The same projection entry also carries `filled`/`target` — the box's own actually-
  // scanned count and its own planned quantity, correctly split across boxes when one
  // item spans more than one box — which is what bug 2's "X of Y Scanned Items" label
  // needs instead of checky()'s whole-box planned qty and the whole-order running
  // scanned total.
  getBoxChampActiveEntry = () => {
    const view = this.getBoxChampView();
    if (!view) return null;
    if (view.projection.activeIndex >= 0) {
      return view.projection.boxes[view.projection.activeIndex] || null;
    }
    // GROOV-4994 (QA pass 3): activeIndex is -1 in two situations that need different
    // handling. (a) there is no BoxChamp plan at all — handled by the caller falling
    // back to the legacy activeBoxIndex prop. (b) a genuine plan exists but every box
    // is momentarily `complete` — the instant the LAST item of the LAST box is
    // scanned, before the packer has confirmed/sealed it.
    //
    // Round 2 tried to detect (b) with a server-completion check (`complete &&
    // !e.sealed`, backed by Box.completed_at). QA live-proved that wrong (order
    // #1675143, real scans, real network capture, DB read immediately after): the
    // server sets completed_at SYNCHRONOUSLY as part of the very API response that
    // also triggers the confirmation modal, so by the time this re-renders the box
    // already reads sealed:true and that check never matches — falling straight
    // through to the stale legacy cursor, the exact bug this exists to fix.
    //
    // The reliable signal is PACKER ACKNOWLEDGMENT, not server completion state.
    // boxChampPendingConfirmationBoxId (threaded down from
    // scanpack_item.js's getBoxChampHandoff().sealBox — the SAME value that actually
    // drives the confirm modal, gated on boxChampSealConfirmedBoxIds/
    // boxChampAutoSealedIds()) is that signal. Look the box up by that id rather than
    // re-deriving an equivalent heuristic locally — a second implementation is exactly
    // how round 2 drifted from reality.
    const pendingId = this.props.boxChampPendingConfirmationBoxId;
    if (pendingId == null) return null;
    return view.projection.boxes.find(e => e.box.id === pendingId) || null;
  };

  render() {
    const scannedItems =
      this.props?.order?.order?.scanned_items
    SortList(this.props?.Order?.order_item_boxes);
    let updatedScannedlist = filterScannedList(this.props?.order?.order?.scanned_items)
    let multiBoxLength = this.props?.Order?.order_item_boxes?.length;
    const multi_box_shipments = this.props?.bothSettings?.data?.data?.general_setting?.multi_box_shipments;
    const windowWidth = Dimensions.get('window').width;
    const windowHeight = Dimensions.get('window').height;
    let props = this.props;
    let localCount = 0;
    this.props?.order?.order?.scanned_items &&
      this.props.order.order.scanned_items.length > 0 &&
      this.props.order.order.scanned_items.map(item => {
      localCount = localCount + item?.scanned_qty;
      });
    count = localCount;
    // GROOV-4994 (bugs 1 & 2): resolve the box this panel should treat as "currently
    // active" once, up front — from the always-current guided-view projection when a
    // BoxChamp plan exists, falling back to the legacy activeBoxIndex prop otherwise —
    // and use it consistently everywhere below (header name/position, the scanned-count
    // label, the item list's own box filter, and the child items' activeBoxName), so the
    // panel's header can never show a different box than the items rendered under it.
    const boxChampView = this.getBoxChampView();
    const boxChampActiveEntry = this.getBoxChampActiveEntry();
    const activeBox = boxChampActiveEntry
      ? boxChampActiveEntry.box
      : this.props?.Order?.boxes?.[this.props.activeBoxIndex];
    // Look up the entry's own position rather than reusing view.projection.activeIndex
    // directly — that index is -1 in the "pending confirmation" case handled above, so
    // reading it here would render "Box 0 of N" for exactly the state this fix exists
    // to correct.
    const activeBoxPosition = boxChampActiveEntry
      ? boxChampView.projection.boxes.indexOf(boxChampActiveEntry) + 1
      : this.props.activeBoxIndex + 1;
    const activeBoxScannedCount = boxChampActiveEntry
      ? boxChampActiveEntry.filled
      : this.checky(activeBox?.id);
    const activeBoxTargetCount = boxChampActiveEntry
      ? boxChampActiveEntry.target
      : count;
    let perPage = this.state.scannedItemPerPage * 10;
    return (
      <View
        style={
          Platform.OS === 'web'
            ? styles.scannedItemContainerWeb
            : styles.scannedItemContainer
        }>
        {Platform.OS === 'web' ? (
          <View style={{flex: 1}}>
            <ImageBackground source={backNewImage} style={{height: '100%'}}>
              {/* Inside the artwork, not above it: rendered as a sibling it
                  displaced this full-height ImageBackground and exposed the
                  container's own grey underneath. */}
              <BoxChampReopenPrompt
                box={this.state.boxChampReopenBox}
                onConfirm={this.confirmBoxChampReopen}
                onCancel={this.cancelBoxChampReopen}
              />
              {multi_box_shipments && scannedItems?.length > 0 ? (
                <View
                  testID="multiBox"
                  style={{
                    textAlign: 'center',
                    backgroundColor: '#000',
                    padding: multiBoxLength === 0 ? 27 : 0
                  }}>
                  <Text
                    testID="activeBoxNameHeader"
                    style={{
                      color: '#D7D7D7',
                      marginTop: '3px',
                      fontSize: '18px',
                      fontFamily: 'Poppins_600SemiBold'
                    }}>
                    {this.props?.Order?.boxes.length > 0 && activeBox?.name}
                  </Text>
                  {this.props?.Order?.boxes?.length > 1 && (
                    <Text
                      testID="boxPositionIndicator"
                      style={{
                        color: '#D7D7D7',
                        fontSize: '14px',
                        fontFamily: 'Poppins_300Light'
                      }}>
                      {/* GROOV-4994 (PR #481 review): activeBoxPosition (the
                          numerator) is derived from boxChampView.projection.boxes,
                          which buildProjection() filters to champ-sourced boxes only.
                          On an order with a mix of champ and non-champ boxes,
                          pairing that numerator with the unfiltered
                          Order.boxes.length denominator could read e.g. "Box 1 of 5"
                          when there are really only 3 champ boxes. Use the same
                          champ-filtered collection (projection.totalBoxes) for the
                          denominator whenever the numerator came from it. */}
                      Box {activeBoxPosition} of{' '}
                      {boxChampActiveEntry
                        ? boxChampView.projection.totalBoxes
                        : this.props.Order.boxes.length}
                    </Text>
                  )}
                  {activeBox?.id && (
                    <Text
                      testID="activeBoxScannedCount"
                      style={{
                        color: 'white',
                        fontSize: '18px',
                        fontFamily: 'Poppins_300Light'
                      }}>
                      {activeBoxScannedCount}{' '}
                      of {activeBoxTargetCount} {I18n.t("nextItems.scannedLabel")}
                    </Text>
                  )}
                </View>
              ) : (
                <Text
                  dataSet={{componentName: 'scannedQtyCount'}}
                  style={[
                    styles.scannedItemTextWeb,
                    {fontFamily: fontFamily.font600}
                  ]}>
                  {count} {I18n.t("nextItems.scannedLabel")}
                </Text>
              )}
              <View>
                {this.props?.Order?.boxes?.length > 1 &&
                  this.props.activeBoxIndex >= 1 && (
                    <View
                      style={{
                        color: 'white',
                        position: 'absolute',
                        marginTop: '0.5%',
                        fontSize: '21px',
                        left: 10
                      }}>
                      <TouchableOpacity
                        style={{flexDirection: 'row', marginTop: '2.5%'}}
                        testID="goPrevIcon"
                        onPress={() => this.props.goPrev()}>
                        <i
                          className="icon-up-open"
                          style={{rotate: '270deg'}}></i>
                        <Text
                          style={{
                            color: 'white',
                            fontSize: '18px'
                          }}>
                          Back
                        </Text>
                      </TouchableOpacity>
                    </View>
                  )}
              </View>
              <View style={{maxHeight: window.innerHeight - 70}}>
              <CustomScrollBar showDefaultStyles={false} >
              {(multi_box_shipments &&
                props?.order?.order?.scanned_items?.length > 0) ||
              props.Order?.order_item_boxes > 0 ? (
                <>
                  {this.props.LoaderDetail.loading ? (
                    <View style={{height: '640px', justifyContent: 'center'}}>
                      <ActivityIndicator size="large" />
                    </View>
                  ) : (
                    <View style={{height: '90%', zIndex: '-1'}}>
                      {this.props.Order?.boxes[this.props?.activeBoxIndex] && (
                        <LinearGradient
                          style={{
                            height: '30px',
                            marginBottom: '5%'
                          }}
                          start={{x: 0, y: 1}}
                          end={{x: 0, y: 0}}
                          colors={['#142130', '#304454']}>
                          {this.props.activeBoxIndex >= 1 && 
                            <TouchableOpacity
                              style={{flexDirection: 'row', marginTop: '1%'}}
                              testID="goPrevIcon"
                              onPress={() => this.props.goPrev()}>
                              <i
                                className="icon-up-open"
                                style={{rotate: '270deg', color: 'white'}}></i>
                              <Text
                                style={{
                                  color: 'white',
                                  fontSize: '18px'
                                }}>
                                Back
                              </Text>
                            </TouchableOpacity>
                          }
                          <TouchableOpacity
                            testID="printSlip"
                            style={{
                              color: 'white',
                              position: 'absolute',
                              right: 105,
                              marginTop: '1%',
                              width: '5%'
                            }}
                            onPress={() => {
                              this.props.printSlipFun();
                            }}>
                            <i
                              className="icon-print"
                              style={{fontSize: '21px'}}></i>
                          </TouchableOpacity>
                          {this.props.activeBoxIndex !==
                            this.props.Order?.boxes?.length - 1 &&
                            this.props.activeBoxIndex !==
                              this.props.Order?.boxes?.length && (
                              <View
                                style={{
                                  color: 'white',
                                  position: 'absolute',
                                  marginTop: '0.5%',
                                  fontSize: '21px',
                                  right: 10
                                }}>
                                <TouchableOpacity
                                  style={{
                                    flexDirection: 'row',
                                    marginTop: '2.5%'
                                  }}
                                  testID="goNextIcon"
                                  onPress={() => this.props.goNext()}>
                                  <Text
                                    style={{
                                      color: 'white',
                                      fontSize: '18px'
                                    }}>
                                    Next
                                  </Text>
                                  <i
                                    className="icon-up-open"
                                    style={{rotate: '90deg'}}></i>
                                </TouchableOpacity>
                              </View>
                            )}

                          {this.props.activeBoxIndex ==
                            this.props.Order?.boxes?.length - 1 && (
                            <TouchableOpacity
                              testID="addBoxIcon"
                              style={{
                                position: 'absolute',
                                marginTop: '1%',
                                fontSize: '21px',
                                left: '90%',
                                color: 'white'
                              }}
                              dataSet={{ componentName: 'addBoxIcon'}}
                              onPress={async () => {
                                this.addBoxMultiBox();
                                // await this.props.GetOrderDetail({ id: this.props?.order?.order?.id })
                              }}>
                              <i className="icon-plus"></i>
                            </TouchableOpacity>
                          )}
                        </LinearGradient>
                      )}
                      {props.Order?.order_item_boxes?.map((order, index) => {
                        return (
                          <>
                            <View>
                              {activeBox?.id === order.box_id && (
                                <>
                                  {props?.order?.order &&
                                  props.order.order.scanned_items.length > 0 ? (
                                    <View>
                                      {scannedItems
                                        .map((item, index) => {
                                          return (
                                            <View>
                                            {(item?.product_id ===
                                              order?.product_id) && order.kit_id === null &&
                                              order.order_item_id === item?.order_item_id &&
                                              (item && item.product_type === 'single') ||
                                              (item && item.product_type === 'depends') ?
                                              (
                                              <ScannedKitItem
                                                item = {item}
                                                order = {order}
                                                activeBoxName = {activeBox?.name}
                                                redirectToItemDetail={item => {
                                                  this.props.redirectToItemDetail(item);
                                                }}
                                                removeBoxItem = {(box_id, order_item_id, kit_id) =>
                                                  {this.removeBoxItem(box_id, order_item_id, kit_id)
                                                }}
                                              />
                                            ):(
                                              <View>
                                              {(item?.scanned_qty > 0) &&
                                              (item?.product_id === order?.product_id) &&
                                              order.order_item_id === item?.order_item_id
                                              && (
                                              <ScannedKitItemContainer
                                                item = {item}
                                                order = {order}
                                                index = {index}
                                                lists = {props.order.order}
                                                activeBoxName = {activeBox?.name}
                                                redirectToItemDetail={item => {
                                                  this.props.redirectToItemDetail(item);
                                                }}
                                                removeBoxItem = {(box_id, order_item_id, kit_id) =>
                                                  {this.removeBoxItem(box_id, order_item_id, kit_id)
                                                }}
                                              />
                                              )}
                                              </View>
                                            )}
                                            </View>
                                          );
                                        })}
                                    </View>
                                  ) : (
                                    <View style={globalStyles.p_10}></View>
                                  )}
                                </>
                              )}
                            </View>
                          </>
                        );
                      })}
                    </View>
                  )}
                </>
              ) : (
                <>
                  {' '}
                  {props?.order?.order &&
                  props.order.order.scanned_items.length > 0 ? (
                    <View>
                      {updatedScannedlist
                        .slice(0, perPage)
                        .map((item, index) => {
                          return (
                            <View key={item?.id}>
                              {(item.scanned_qty > 0 || item.skippable ) &&
                              item?.product_type != "individual" &&
                              (item?.child_items?.length === 0 || item?.child_items === undefined || item?.product_type==='depends') && (
                                <View
                                  key={item?.id}
                                  style={{
                                    flexDirection: 'row',
                                    position: 'relative',
                                    backgroundColor: '#292929',
                                    textAlign: 'left',
                                    display: 'flex',
                                    borderRadius: 12,
                                    marginTop: 5
                                  }}>
                                  <OrderItem
                                    item={item}
                                    redirectToItemDetail={item => {
                                      this.props.redirectToItemDetail(item);
                                    }}
                                    testID={'redirectToItem'}
                                  />
                                  <OrderItemImage
                                    item={item}
                                    shuffleTheItem={() => {}}
                                    listType={'scanned'}
                                  />
                                </View>
                              )}
                            </View>
                          );
                        })}
                    </View>
                  ) : (
                    <View style={globalStyles.p_10} testID="emptyList"></View>
                  )}
                </>
              )}
              {this.props.LoaderDetail.loading === false &&
                props.order.order.scanned_items &&
                props.order.order.scanned_items.length >= perPage && (
                  <View style={{marginTop: '5%'}}>
                    {props.order.order.scanned_items &&
                    props.order.order.scanned_items.length >= perPage ? (
                      <TouchableOpacity
                        testID="showMore"
                        onPress={() => {
                          let perPage = this.state.scannedItemPerPage + 1;
                          this.setState({scannedItemPerPage: perPage});
                        }}>
                        <Text
                          style={{
                            color: '#fff',
                            fontWeight: 'bold',
                            fontSize: 14,
                            zIndex: 99999,
                            textShadowColor: '#000',
                            textShadowOffset: {width: 1, height: 1},
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 8,
                            background: '#41970f',
                            marginRight: 'auto',
                            marginLeft: 'auto',
                            borderRadius: 5,
                            marginTop: 2
                          }}>
                          Show More
                        </Text>
                      </TouchableOpacity>
                    ) : (
                      <TouchableOpacity
                        onPress={() => {
                          let perPage = 1;
                          this.setState({scannedItemPerPage: perPage});
                        }}>
                        <Text
                          style={{
                            color: '#fff',
                            fontWeight: 'bold',
                            fontSize: 14,
                            zIndex: 99999,
                            textShadowColor: '#000',
                            textShadowOffset: {width: 1, height: 1},
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 8,
                            background: '#f54400',
                            marginRight: 'auto',
                            marginLeft: 'auto',
                            borderRadius: 5,
                            marginTop: 2
                          }}>
                          Reset
                        </Text>
                      </TouchableOpacity>
                    )}
                  </View>
                )}
              </CustomScrollBar>
              </View>
            </ImageBackground>
          </View>
        ) : (
          <View style={{height: windowHeight - 90, width: '100%'}}>
            <BoxChampReopenPrompt
              box={this.state.boxChampReopenBox}
              onConfirm={this.confirmBoxChampReopen}
              onCancel={this.cancelBoxChampReopen}
            />
            {props.order &&
            props.order.order &&
            props.order.order.scanned_items.length > 0 ? (
              scannedItems.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    {item.scanned_qty > 0 && (
                      <View
                        key={index}
                        style={{
                          flexDirection: 'row',
                          margin: 0,
                          borderRadius: 30,
                          borderWidth: 4,
                          backgroundColor: '#336598',
                          borderColor: 'black',
                          padding: 10
                        }}>
                        <View style={{flex: 20}}>
                          <TouchableOpacity
                            style={{
                              backgroundColor: '#fff',
                              padding: 5,
                              borderTopLeftRadius: 20,
                              borderTopRightRadius: 20
                            }}>
                            <Text
                              numberOfLines={2}
                              style={
                                item.name && item.name.length <= 32
                                  ? {
                                      fontSize: 20,
                                      maxWidth: '75%',
                                      lineHeight: '100%'
                                    }
                                  : {
                                      fontSize: 16,
                                      maxWidth: '75%',
                                      lineHeight: '100%'
                                    }
                              }>
                              {item.name}
                            </Text>
                          </TouchableOpacity>
                          {item.sku ? (
                            <Text
                              numberOfLines={1}
                              ellipsizeMode="tail"
                              style={{
                                color: '#fff',
                                fontSize: 20,
                                fontWeight: '600',
                                maxWidth: '70%'
                              }}>
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontFamily: fontFamily.font400,
                                  fontWeight: 'bold'
                                }}>
                                SKU :{' '}
                              </Text>
                              {item.sku}
                            </Text>
                          ) : (
                            <></>
                          )}
                          <View
                            style={{
                              backgroundColor: '#95b0e5',
                              paddingLeft: 3,
                              paddingRight: 3
                            }}>
                            <View
                              style={{maxWidth: '70%', flexDirection: 'row'}}>
                              {item.location !== null &&
                                item.location !== '' &&
                                item.location !== undefined && (
                                  <View
                                    style={{
                                      flex: 1,
                                      flexDirection: 'row',
                                      alignItems: 'baseline',
                                      height: 25
                                    }}>
                                    <Text>L1 : </Text>
                                    <Text
                                      numberOfLines={1}
                                      ellipsizeMode="tail"
                                      style={{
                                        fontSize: 20,
                                        fontWeight: 'bold',
                                        paddingRight: 10
                                      }}>
                                      {item.location}
                                    </Text>
                                  </View>
                                )}
                              {item.custom_product_1 !== null &&
                                item.custom_product_1 !== '' &&
                                item.custom_product_1 !== undefined && (
                                  <View
                                    style={{
                                      flex: 1,
                                      flexDirection: 'row',
                                      alignItems: 'baseline',
                                      height: 25
                                    }}>
                                    <Text>C1:</Text>
                                    <Text
                                      numberOfLines={1}
                                      ellipsizeMode="tail"
                                      style={{
                                        fontSize: 20,
                                        fontWeight: 'bold'
                                      }}>
                                      {item.custom_product_1}
                                    </Text>
                                  </View>
                                )}
                            </View>
                          </View>
                          <View
                            style={{
                              backgroundColor: '#d3def4',
                              padding: 3,
                              borderBottomLeftRadius: 20,
                              borderBottomRightRadius: 20
                            }}>
                            <Text
                              style={{fontSize: 20, maxWidth: '75%'}}
                              numberOfLines={1}
                              ellipsizeMode="tail">
                              {item &&
                                item.barcodes.length > 0 &&
                                item.barcodes[0].barcode}
                            </Text>
                          </View>
                        </View>

                        <View
                          style={{
                            flex: 5,
                            borderBottomRightRadius: 12,
                            borderTopRightRadius: 12,
                            position: 'absolute',
                            right: 6,
                            width: '25%',
                            height: '100%',
                            bottom: 0
                          }}>
                          <View
                            style={{
                              backgroundColor: '#fff',
                              shadowColor: '#000',
                              shadowOffset: {width: -5, height: 2},
                              shadowOpacity: 0.25,
                              shadowRadius: 3.84,
                              elevation: 3,
                              borderRadius: 12,
                              borderWidth: 8,
                              borderColor: '#336598',
                              height: '100%'
                            }}>
                            <Text
                              style={{
                                position: 'absolute',
                                textAlign: 'center',
                                fontSize: 18,
                                fontWeight: '600',
                                backgroundColor: '#fff',
                                opacity: 0.7,
                                bottom: 0,
                                right: 0,
                                left: 0,
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                zIndex: 999
                              }}>
                              {item.scanned_qty}/
                              {item.qty_remaining + item.scanned_qty}
                            </Text>
                            {item?.images && item?.images?.length > 0 ? (
                              <Image
                                defaultSource={placeholder}
                                source={{uri: item.images[0].image}}
                                style={{
                                  height: '100%',
                                  width: '96%',
                                  resizeMode: 'cover',
                                  borderRadius: 12
                                }}
                              />
                            ) : (
                              <Image
                                source={placeholder}
                                style={{
                                  height: '100%',
                                  width: '96%',
                                  resizeMode: 'cover',
                                  borderRadius: 12
                                }}
                              />
                            )}
                          </View>
                        </View>
                      </View>
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <View style={globalStyles.p_10}></View>
            )}
          </View>
        )}
      </View>
    );
  }
}

const mapDispatchToProps = {
  AddBox,
  GetOrderDetail,
  RemoveBoxItems,
  GetProductDetail,
  PrintSlip,
  LoaderShow
};
const mapStateToProps = state => {
  return {
    LoaderDetail: state.orderLoader,
    orderDetails : state.order.order
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScannedItems);
